import { SvgIcon } from '@mui/material';
import { EntityDefaultLogo } from '@opengov/react-capital-assets';
import React from 'react';

import { DATA_TEST } from '../../enums';

interface IEntityLogoProps {
  entityName: string;
  customLogoUrl?: string;
}

export const EntityLogo: React.FC<IEntityLogoProps> = ({ entityName, customLogoUrl = '' }) => {
  const [logoUrl, setLogoUrl] = React.useState(customLogoUrl);
  const handleError = () => setLogoUrl('');

  return (
    <>
      {logoUrl ? (
        <img
          data-test={DATA_TEST.entity_switcher_custom_logo}
          onError={handleError}
          src={logoUrl}
          alt={`${entityName} logo`}
          style={{
            height: '20px',
            width: '24px',
            objectFit: 'contain'
          }}
        />
      ) : (
        <SvgIcon
          data-test={DATA_TEST.entity_switcher_default_logo}
          aria-label={EntityDefaultLogo?.displayName}
          component={EntityDefaultLogo}
          sx={{ height: '20px', width: '24px', objectFit: 'contain' }}
        />
      )}
    </>
  );
};
